/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DataBase Common API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseDatabaseEnabledCountResponse,
  ApiResponseDatabaseInfoRs,
  ApiResponseDatabaseResponseWithColumn,
  ApiResponseInstanceInformationItemV8,
  GetV8DatabaseInstancesEnabledParams,
  GetV8DatabaseInstancesParams,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getV8Instances
 */
export const getV8DatabaseInstances = (
  params?: MaybeRef<GetV8DatabaseInstancesParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseDatabaseResponseWithColumn>(
    { url: `/api/v8/database/instances`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DatabaseInstancesQueryKey = (
  params?: MaybeRef<GetV8DatabaseInstancesParams>,
) => {
  return ['api', 'v8', 'database', 'instances', ...(params ? [params] : [])] as const;
};

export const getGetV8DatabaseInstancesQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DatabaseInstances>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DatabaseInstancesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DatabaseInstances>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DatabaseInstancesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DatabaseInstances>>> = ({ signal }) =>
    getV8DatabaseInstances(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DatabaseInstances>>,
    TError,
    TData
  >;
};

export type GetV8DatabaseInstancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DatabaseInstances>>
>;
export type GetV8DatabaseInstancesQueryError = ErrorType<unknown>;

/**
 * @summary getV8Instances
 */

export function useGetV8DatabaseInstances<
  TData = Awaited<ReturnType<typeof getV8DatabaseInstances>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DatabaseInstancesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DatabaseInstances>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DatabaseInstancesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getEnableInstances
 */
export const getV8DatabaseInstancesEnabled = (
  params?: MaybeRef<GetV8DatabaseInstancesEnabledParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseDatabaseEnabledCountResponse>(
    { url: `/api/v8/database/instances/enabled`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV8DatabaseInstancesEnabledQueryKey = (
  params?: MaybeRef<GetV8DatabaseInstancesEnabledParams>,
) => {
  return ['api', 'v8', 'database', 'instances', 'enabled', ...(params ? [params] : [])] as const;
};

export const getGetV8DatabaseInstancesEnabledQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8DatabaseInstancesEnabled>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DatabaseInstancesEnabledParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DatabaseInstancesEnabled>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8DatabaseInstancesEnabledQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV8DatabaseInstancesEnabled>>> = ({
    signal,
  }) => getV8DatabaseInstancesEnabled(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8DatabaseInstancesEnabled>>,
    TError,
    TData
  >;
};

export type GetV8DatabaseInstancesEnabledQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8DatabaseInstancesEnabled>>
>;
export type GetV8DatabaseInstancesEnabledQueryError = ErrorType<unknown>;

/**
 * @summary getEnableInstances
 */

export function useGetV8DatabaseInstancesEnabled<
  TData = Awaited<ReturnType<typeof getV8DatabaseInstancesEnabled>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV8DatabaseInstancesEnabledParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV8DatabaseInstancesEnabled>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8DatabaseInstancesEnabledQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 인스턴스 디테일 > 정보탭
 */
export const getV8Metav6DatabaseInstanceInformationByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseInstanceInformationItemV8>(
    { url: `/api/v8/metav6/database-instance/${instanceId}/information`, method: 'GET', signal },
    options,
  );
};

export const getGetV8Metav6DatabaseInstanceInformationByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
) => {
  return ['api', 'v8', 'metav6', 'database-instance', instanceId, 'information'] as const;
};

export const getGetV8Metav6DatabaseInstanceInformationByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8Metav6DatabaseInstanceInformationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8Metav6DatabaseInstanceInformationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8Metav6DatabaseInstanceInformationByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8Metav6DatabaseInstanceInformationByInstanceId>>
  > = ({ signal }) =>
    getV8Metav6DatabaseInstanceInformationByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8Metav6DatabaseInstanceInformationByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8Metav6DatabaseInstanceInformationByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8Metav6DatabaseInstanceInformationByInstanceId>>
>;
export type GetV8Metav6DatabaseInstanceInformationByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 인스턴스 디테일 > 정보탭
 */

export function useGetV8Metav6DatabaseInstanceInformationByInstanceId<
  TData = Awaited<ReturnType<typeof getV8Metav6DatabaseInstanceInformationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8Metav6DatabaseInstanceInformationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8Metav6DatabaseInstanceInformationByInstanceIdQueryOptions(
    instanceId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 정보탭 > 클러스터 데이터베이스 목록
 */
export const getV8ClusterDatabaseListByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseDatabaseInfoRs>(
    { url: `/api/v8/${instanceId}/cluster-database-list`, method: 'GET', signal },
    options,
  );
};

export const getGetV8ClusterDatabaseListByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v8', instanceId, 'cluster-database-list'] as const;
};

export const getGetV8ClusterDatabaseListByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV8ClusterDatabaseListByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8ClusterDatabaseListByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV8ClusterDatabaseListByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV8ClusterDatabaseListByInstanceId>>
  > = ({ signal }) => getV8ClusterDatabaseListByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV8ClusterDatabaseListByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV8ClusterDatabaseListByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV8ClusterDatabaseListByInstanceId>>
>;
export type GetV8ClusterDatabaseListByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 정보탭 > 클러스터 데이터베이스 목록
 */

export function useGetV8ClusterDatabaseListByInstanceId<
  TData = Awaited<ReturnType<typeof getV8ClusterDatabaseListByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV8ClusterDatabaseListByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV8ClusterDatabaseListByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
